import React from 'react';
import { Typography } from '@mui/material';
import styled from 'styled-components';

import ApplicationBar from 'components/ApplicationBar';
import Paper from 'components/Paper';

const StyledHome = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  margin: 1rem;

  & > *:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

const StyledPaper = styled(Paper)`
  width: 100%;
`;

const Home: React.FC = () => {
  return (
    <StyledHome>
      <ApplicationBar />
      <div
        style={{
          padding: '1rem',
          width: '100%',
          border: 'solid 1px lightgrey',
          backgroundColor: 'white',
          boxShadow: '2px 2px 5px 0px rgba(0, 0, 0, 0.5)',
        }}
      >
        <Typography>Select a collection</Typography>
      </div>
    </StyledHome>
  );
};

export default Home;
